/*Kelvin Roger Ang Yap 2017
	krayap@gmail.com
*/
//import on files
Vue.component('kr-search', require('./components/kr-search.vue').default);
